import React from "react";
import T from "prop-types";
import { withShipment } from "MODULES/OutgoingShipments/decorators";
import { translateProps } from "MODULES/shared/decorators";
import { StatusTag } from "MODULES/shared/components";

export function AccountHold({ hold }) {
  return (
    hold && <StatusTag title="Accounting Hold" icon="pause" display="warning" />
  );
}

AccountHold.propTypes = {
  hold: T.bool
};

const withProps = translateProps(({ shipment }) => ({
  hold: shipment.get("accounting_hold")
}));

export default withShipment(withProps(AccountHold));



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Warnings/AccountingHold.jsx